module.exports = __webpack_public_path__ + "img/17.5c9fda74.jpg";